import { ComponentType } from 'react';

import TripPlannerChatConversationsPage from './TripPlannerChatConversationsPage';
import TripPlannerChatStatsPage from './TripPlannerChatStatsPage';

type TripPlannerChatTab = {
  path: string;
  title: string;
  component: ComponentType;
};

export const tripPlannerChatTabs: ReadonlyArray<TripPlannerChatTab> = [
  {
    path: '/trip-planner/chat/trips',
    title: 'Trips',
    component: TripPlannerChatConversationsPage,
  },
  {
    path: '/trip-planner/chat/stats',
    title: 'Stats',
    component: TripPlannerChatStatsPage,
  },
];
